/* REACT PACKAGE IMPORTS */
import { useState } from "react";
import { Offcanvas } from "react-bootstrap";

/* MUI PACKAGE IMPORTS */
import Divider from '@mui/material/Divider';

export default function SideModal({
  title,
  children,
  isVisible,
  setIsVisible,
}) {
  return (
    <Offcanvas
      show={isVisible}
      onHide={() => setIsVisible(false)}
      placement="end"
      className="background-secondary"
      aria-label={`${title} Form`}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title id="Offcanvas-styling-title">
          <p className="text-theme fw-bold m-0 h4">{title}</p>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Divider />
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
}
